import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";
let appInsights = false, reactPlugin;
if (process.env.INSIGHT_CONNECTION_STRING) {
    const browserHistory = createBrowserHistory({ basename: '' });
    reactPlugin = new ReactPlugin();

    appInsights = new ApplicationInsights({
        config: {
            connectionString: process.env.INSIGHT_CONNECTION_STRING,
            extensions: [reactPlugin],
            extensionConfig: {
                [reactPlugin.identifier]: {
                    history: browserHistory
                }
            }
        }
    });
    appInsights.loadAppInsights();
}
let lastUserId = null;
// Function to set user identity (call this after user logs in)
export function setAppInsightsUser(userId, accountId = null) {
    if (appInsights && userId && userId !== lastUserId) {
        lastUserId = userId;
        appInsights.setAuthenticatedUserContext(userId, accountId, true);
    }
};

// Function to clear user identity (call this on logout)
export function clearAppInsightsUser() {
    if (appInsights) 
        appInsights.clearAuthenticatedUserContext();
};

export function trackException(data) {
    if (appInsights) {
        if (window?.context?.user) {
            if (!data.properties) data.properties = {};
            if (!data.properties.user) data.properties.user = {};
            ["name", "contactid", "firstname", "lastname", "emailaddress1" ]
                .forEach(key => {
                    if (window.context.user[key]) {
                        data.properties.user[key] = window.context.user[key];
                    }
                });
        }
        appInsights.trackException(data);
    }
}
export default function withApplicationInsight(Component) {
    if (appInsights) {
        return withAITracking(reactPlugin, Component);
    }
    return Component;
}